import React, { useState, useEffect } from 'react';
import locale2 from 'locale2'
import classnames from 'classnames';

function pad(num){
    let displayNum = num;

    if( num < 10 ){
      displayNum = '0' + num;
    }

  return displayNum;
}

function pmToMilitaryConversion(pm, hour){
  // convert hour into 12
  if(pm === false){
    // changing to am
    // or
    // convert to military am hour
    if( hour >= 12 ){
      return hour - 12;
    }
  }else if( pm === true ){
    // changing to pm
    // or
    // convert to military pm hour
    if( hour < 12){
      return hour + 12;
    }
  }

  return hour;
};

function militaryToPmConversion(hour){
  if( hour > 12 ){
    hour = hour - 12;
  }else if(hour === 0){
    hour = 12;
  }

  return hour;
};

function pmString(isPm){
  return isPm ? 'pm' : 'am';
}

function formatTime(locale, pm, hour, minute){
    //if( locale === 'en-US' ){
    if( true ){
      hour = militaryToPmConversion(hour);
      return `${hour}:${pad(minute)}${pmString(pm)}`;
    }else{
      return `${pad(hour)}:${pad(minute)}`;
    }
}

export default function Time(props){

  const [isPm,setPm] = useState(true);

  useEffect(()=>{
    props.setFormattedTime(formatTime( locale2, isPm, props.hour, props.minute ));
  },[]);

  const handleHourChange = (event)=> {

    let hour = pmToMilitaryConversion( isPm, parseInt( event.target.value ) );

    props.setFormattedTime(formatTime( locale2, isPm, hour, props.minute ));

    props.setHour(hour);
  }

  const handleMinuteChange = (event)=> {
    let minute = parseInt( event.target.value );
    props.setFormattedTime(formatTime( locale2, isPm, props.hour, minute));
    props.setMinute(minute);
  }

  // don't check locacle this fires only
  // if the select is already displayed
  const handlePmChange = (event)=> {

    let pm = !isPm;

    let hour = pmToMilitaryConversion( pm, props.hour );

    props.setFormattedTime(formatTime( locale2, pm, hour, props.minute ));
    props.setHour(hour);
    setPm( pm );
  }

  let hourOptions = [...Array(24)].map((x, i) =>
        <option value={i} key={i}>{pad(i)}</option>
  );

  let amPm = "";
  let hour = props.hour;

  //if( locale2 === 'en-US' ){
  if( true ){

    hour = militaryToPmConversion(hour);

    hourOptions = [...Array(11)].map((x, i) =>
        <option value={i+1} key={i+1}>{pad(i+1)}</option>
    );

    hourOptions.unshift(<option value={12} key={12}>{12}</option>);

    amPm = (<select
          className="form-control form-control-lg ampm"
          onChange={handlePmChange}
          value={isPm}
        >
          <option value="true" key="pm">pm</option>
          <option value="false" key="am">am</option>
        </select>);
  }

  let classes = classnames(
    "d-inline-flex", "flex-row", "time-form",
    {
      'border': props.timeValidation,
      'border-success': props.timeValidation,
    });

  return(<div className={classes}>
        <select
          className="form-control form-control-lg hour"
          onChange={handleHourChange}
          value={hour}
        >
          {hourOptions}

        </select>
        <label className="time-label">:</label>
        <select
          className="form-control form-control-lg minute"
          onChange={handleMinuteChange}
          value={props.minute}
        >

        {[...Array(60)].map((x, i) =>
            <option value={i} key={i}>{pad(i)}</option>
        )}
        </select>
        {amPm}
    </div>);
}
